import { detectedCulture } from '@/utilities/common/culture'
import auth from '@/utilities/udi/udi'
import Vue from 'vue'
import store from 'store'
import Router from 'vue-router'
// import Checkout from 'views/Checkout.vue'
import SubscriptionSuccessful from 'views/SubscriptionSuccessful.vue'
import MyAccount from 'views/MyAccount.vue'
import Overview from 'views/my-account/Overview.vue'
import PersonalDetails from 'views/my-account/PersonalDetails.vue'
import PaymentDetails from 'views/my-account/PaymentDetails.vue'
import Billing from 'views/my-account/Billing.vue'
import Support from 'views/my-account/Support.vue'
import SubscriptionError from 'views/SubscriptionError.vue'
import SubscriptionCancel from 'views/SubscriptionCancel.vue'
import SubscriptionDetails from 'views/SubscriptionDetails.vue'
import PaymentResult from 'views/PaymentResult.vue'
import SubscriptionThankyou from 'views/SubscriptionThankyou.vue'
import UDIReturn from 'views/UDIReturn.vue'
import SubscriptionReturn from 'views/SubscriptionReturn.vue'
import NotFound from 'views/404'
import LoginAdmin from 'views/LoginAdmin'
import { updatePageName } from 'utilities/common/trackConversion'
import SubscriptionPurchase from 'views/SubscriptionPurchase'
import ShoppingCart from 'views/ShoppingCart'
import Checkout from 'views/Checkout'
import SubscriptionPaymentDetail from 'views/SubscriptionPaymentDetail'
import PayNowSuccessful from 'views/PayNowSuccessful'
import ContractCancel from 'views/ContractCancel'

Vue.use(Router)

const scrollBehavior = function (to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition
  } else {
    if (to.meta.scrollToTop) {
      return { x: 0, y: 0 }
    }
  }
}

const router = new Router({
  mode: 'history',
  base: detectedCulture ? detectedCulture.code : '',
  scrollBehavior,
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: '/checkout'
    },
    {
      path: '/cart',
      name: 'cart',
      component: ShoppingCart,
      meta: {
        pageName: 'cart',
        scrollToTop: true
      }
    },
    {
      path: '/checkout-steps',
      redirect: { name: 'checkout' },
      meta: {
        pageName: 'checkout',
        scrollToTop: true
      }
    },
    {
      path: '/checkout',
      name: 'checkout',
      component: Checkout,
      meta: {
        pageName: 'checkout',
        scrollToTop: true
      }
    },
    {
      path: '/subscription-successful',
      name: 'subscription-successful',
      component: SubscriptionSuccessful,
      meta: {
        pageName: 'subscription_successful',
        requireAuth: true
      }
    },
    {
      path: '/subscription-contractcancel',
     name: 'subscription-contractcancel',
       component: ContractCancel,
       meta: {
         pageName: 'subscription-contractcancel',
        
       }
     },
    {
      path: '/subscription-error',
      name: 'subscription-error',
      component: SubscriptionError,
      meta: {
        pageName: 'subscription_error',
        requireAuth: true
      }
    },
    {
      path: '/pay-now-successful',
      name: 'pay-now-successful',
      component: PayNowSuccessful,
      meta: {
        pageName: 'subscription_successful',
        requireAuth: true
      }
    },
    {
      path: '/my-account',
      name: 'my-account',
      component: MyAccount,
      meta: {
        requireAuth: true,
        scrollToTop: true
      },
      children: [
        {
          path: 'overview',
          name: 'overview',
          component: Overview,
          meta: {
            pageName: 'my_account:overview',
            requireAuth: true,
            myAccountSubPage: true
          },
          beforeEnter: (to, from, next) => {
            updatePageName(to.meta.pageName)
            next()
          }
        },
        {
          path: 'personal-details',
          name: 'personal-details',
          component: PersonalDetails,
          meta: {
            pageName: 'my_account:personal_details',
            requireAuth: true,
            myAccountSubPage: true
          },
          beforeEnter: (to, from, next) => {
            updatePageName(to.meta.pageName)
            next()
          }
        },
        {
          path: 'payment-details',
          name: 'payment-details',
          component: PaymentDetails,
          meta: {
            pageName: 'my_account:payment_method',
            requireAuth: true,
            myAccountSubPage: true
          },
          beforeEnter: (to, from, next) => {
            updatePageName(to.meta.pageName)
            next()
          }
        },
        {
          path: 'billing',
          name: 'billing',
          component: Billing,
          meta: {
            pageName: 'my_account:billing',
            requireAuth: true,
            myAccountSubPage: true
          },
          beforeEnter: (to, from, next) => {
            updatePageName(to.meta.pageName)
            next()
          }
        },
        {
          path: 'support',
          name: 'support',
          component: Support,
          meta: {
            pageName: 'my_account:support',
            requireAuth: true,
            myAccountSubPage: true
          },
          beforeEnter: (to, from, next) => {
            updatePageName(to.meta.pageName)
            next()
          }
        }
      ]
    },
    {
      path: '/my-account/subscription-details/:id',
      name: 'subscription-details',
      component: SubscriptionDetails,
      meta: {
        pageName: 'my_subscriptions_overview',
        requireAuth: true,
        scrollToTop: true
      }
    },
    {
      path: '/my-account/subscription-cancel/:id',
      name: 'subscription-cancel',
      component: SubscriptionCancel,
      meta: {
        pageName: 'my_subscriptions_overview',
        requireAuth: true,
        scrollToTop: true
      }
    },
    {
      path: '/my-account/subscription-thankyou/:id',
      name: 'subscription-thankyou',
      component: SubscriptionThankyou,
      meta: {
        pageName: 'my_subscriptions_overview',
        requireAuth: true,
        scrollToTop: true
      }
    },
    {
      path: '/my-account/subscription-return/:id',
      name: 'subscription-return',
      component: SubscriptionReturn,
      meta: {
        requireAuth: true,
        scrollToTop: true
      }
    },
    {
      path: '/my-account/subscription-purchase/:id',
      name: 'subscription-purchase',
      component: SubscriptionPurchase,
      meta: {
        pageName: 'my_subscriptions_overview',
        requireAuth: true,
        scrollToTop: true
      }
    },
    {
      path: '/my-account/subscription-payment-detail/:id',
      name: 'subscription-payment-detail',
      component: SubscriptionPaymentDetail,
      meta: {
        pageName: 'my_subscriptions_overview',
        requireAuth: true,
        scrollToTop: true
      }
    },
    {
      path: '/payment-result',
      name: 'payment-result',
      component: PaymentResult,
      meta: {
        requireAuth: true
      },
      beforeEnter: (to, from, next) => {
        if (/LOCAL$/.test(to.query.merchantReference) && process.env.VUE_APP_CONFIG !== 'development') {
          window.location.href = `http://localhost:8080${to.fullPath}`
        }
        next()
      }
    },
    {
      path: '/udi-return',
      name: 'udi-return',
      component: UDIReturn
    },
    {
      path: '/login',
      redirect: '/my-account/overview'
    },
    {
      path: '/login-admin',
      name: 'login-admin',
      component: LoginAdmin,
      meta: {
        pageName: 'login',
        scrollToTop: true
      }
    },
    {
      path: '/404',
      name: 'not-found',
      component: NotFound
    },
    {
      path: '*',
      redirect: { name: 'not-found' }
    }
  ]
})

router.beforeEach((to, from, next) => {
  let token = window.sessionStorage.getItem('Philips-User-Token')
  if (!token) {
    store.commit('account/deleteToken')
    store.dispatch('account/reset')
  }

  // router authority
  if (store.state.account.token) {
    if (to.path === '/login') {
      next({ path: '/my-account' })
    } else {
      next()
    }
  } else {
    if (to.meta && to.meta.requireAuth) {
      auth.login({ returnUrl: to.fullPath })
    } else {
      next()
    }
  }
})

export default router
